<template>
  <div class="app flex-row align-items-center bg-img" :style="{'background-image': randomImage}">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <h1>Redefinir Senha</h1>
                <p class="text-muted">Digite uma nova senha e clique enviar!</p>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="fas fa-lock"></i></span>
                  <b-form-input type="password"
                          id="password"
                          name="password"
                          :placeholder="$lang.Login.NewPassword"
                          v-model="password"
                          data-vv-as="senha"
                          v-validate="'required'"
                          aria-describedby="passwordErrorFeedback"
                          >
                  </b-form-input>
                </div>
                <div class="row">
                  <div class="col-12 pb-4">
                    <div class="required-field-bottom">
                      <small class="pl-2 text-muted">
                        A senha deve conter no mínimo 6 caractéres!
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-left">
                    <router-link :to="{ name: 'SignIn' }" class="btn btn-link px-0"><i class="fa fa-home"></i> Home</router-link>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-third px-4" @click="onResetPassword"><i class="fa fa-check-circle"></i> Enviar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChangeZpag from './changeZpag'

export default ChangeZpag
</script>

<style scoped>

.imagem {
  display: flex;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/views/public/password/changeZpag/changeZpag.vue